import { CellAddressPickerValue, WorksheetValidation } from '../types';

export function useCellAddressFormatter(getWorksheet: (params: { id?: string; name?: string }) => WorksheetValidation) {
  const buildInputValue = (value: CellAddressPickerValue | null): string => {
    if (!value) {
      return '';
    }

    if (value.customRange) {
      return value.customRange;
    }

    if (!value.worksheetId) {
      return value.address;
    }

    if (!value.address) {
      return '';
    }

    const sheet = getWorksheet({ id: value.worksheetId }).worksheet;
    return `${sheet?.name || ''}!${value.address}`;
  };

  return { buildInputValue };
}
